var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"add-list-icon crevo-icon",class:_vm.klass})
}
var staticRenderFns = []

export { render, staticRenderFns }